<span class="p-float-label">
    <!-- placeholder="{{'GENERAL.CHOOSE'|translate}} {{'GENERAL.GROUP'|translate}}" -->
    <p-dropdown [showClear]="true" id="group" [options]="companyGroups" [(ngModel)]="selectedGroup"
        [autoDisplayFirst]="false" optionLabel="name" optionValue="name" [filter]="true" ></p-dropdown>
    <!-- 
       <p-dropdown [options]="companyGroups" [(ngModel)]="selectedGroup"  [showClear]="true" placeholder="Select a Country">
        <ng-template pTemplate="selectedItem">
            <div class="country-item country-item-value"  *ngIf="selectedCountry">
                <img src="assets/showcase/images/demo/flag/flag_placeholder.png" [class]="'flag flag-' + selectedCountry.code.toLowerCase()" />
                <div>{{selectedCountry.name}}</div>
            </div>
        </ng-template>
        <ng-template let-country pTemplate="item">
            <div class="country-item">
                <img src="assets/showcase/images/demo/flag/flag_placeholder.png" [class]="'flag flag-' + country.code.toLowerCase()" />
                <div>{{country.name}}</div>
            </div>
        </ng-template>
    </p-dropdown> -->

    <label>{{ 'GENERAL.GROUP' | translate }}</label>
</span>